var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrediction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.586,
    height: 29.586,
    viewBox: "0 0 29.586 29.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prediction",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3125",
    "data-name": "Path 3125",
    d: "M21.117,135.623a37.018,37.018,0,0,1,14.234,2.97l.171.08a27.324,27.324,0,0,0-4.079-3.744,22.206,22.206,0,0,0-4.589-2.686A14.685,14.685,0,0,0,21.117,131a14.685,14.685,0,0,0-5.737,1.243,22.21,22.21,0,0,0-4.589,2.686,27.321,27.321,0,0,0-4.079,3.744l.171-.08A37.018,37.018,0,0,1,21.117,135.623Z",
    transform: "translate(-6.324 -123.43)",
    fill: "#fac668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3126",
    "data-name": "Path 3126",
    d: "M12.761,269.436l-.587.273a27.983,27.983,0,0,0,3.764,3.391,24.582,24.582,0,0,0,2.083,1.4,10.057,10.057,0,0,1-1.87-5.852c0-.15,0-.3.012-.451A29.16,29.16,0,0,0,12.761,269.436Z",
    transform: "translate(-11.471 -252.701)",
    fill: "#fac668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3127",
    "data-name": "Path 3127",
    d: "M404.489,269.741l-.587-.273a29.413,29.413,0,0,0-3.4-1.235c.007.15.011.3.011.449a10.057,10.057,0,0,1-1.87,5.852,24.574,24.574,0,0,0,2.083-1.4A27.981,27.981,0,0,0,404.489,269.741Z",
    transform: "translate(-375.607 -252.733)",
    fill: "#fac668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3128",
    "data-name": "Path 3128",
    d: "M119.908,254.575a8.388,8.388,0,0,0,8.379-8.379,8.2,8.2,0,0,0-.056-.949,36.064,36.064,0,0,0-4.793-.872,4.189,4.189,0,1,1-7.054-.007,36.02,36.02,0,0,0-4.8.863,8.212,8.212,0,0,0-.058.965A8.388,8.388,0,0,0,119.908,254.575Z",
    transform: "translate(-105.084 -230.247)",
    fill: "#fac668"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 2.456,
    cy: 2.456,
    r: 2.456,
    transform: "translate(12.337 13.926)",
    fill: "#fac668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3129",
    "data-name": "Path 3129",
    d: "M184.155,6.583l-2.664-5.329a2.269,2.269,0,0,0-4.059,0l-2.664,5.329a15.125,15.125,0,0,1,9.388,0Z",
    transform: "translate(-164.668)",
    fill: "#fac668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3130",
    "data-name": "Path 3130",
    d: "M29.346,373.087l-2.517-5.034q-.324.258-.672.519a23.939,23.939,0,0,1-4.95,2.894,16.405,16.405,0,0,1-6.414,1.38,16.405,16.405,0,0,1-6.414-1.38,23.941,23.941,0,0,1-4.95-2.894q-.348-.26-.672-.519L.24,373.087a2.269,2.269,0,0,0,2.03,3.284H27.317a2.269,2.269,0,0,0,2.03-3.284Z",
    transform: "translate(0 -346.785)",
    fill: "#fac668"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrediction);
export default __webpack_public_path__ + "static/media/prediction.0010ecf4.svg";
export { ForwardRef as ReactComponent };